module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('range', {
    attrs: {
      "label": _vm.$t('edit.sidebar.height'),
      "min": "50",
      "max": "150",
      "step": "1",
      "value": _vm.value(),
      "change": _vm.onChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1bea61a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/Height.vue
 ** module id = 777
 ** module chunks = 1
 **/